export default __webpack_public_path__ + "media/images/magnify-5fb9528617c4d42b7237634da981f8f6.png";